export const generateAddressString = data => {
  if (!data) {
    return 'Default Address';
  }
  return "".concat(data.street, " ").concat(data.city, ", ").concat(data.state, " ").concat(data.zip).concat(data !== null && data !== void 0 && data.secondary ? ', ' + data.secondary : '');
};